import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=6bce43ba&lang=less"
import "./index.vue?vue&type=style&index=1&id=6bce43ba&lang=less&scoped=true"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bce43ba"]])

export default __exports__